import { render } from "./balkenMitBildPolstermaterial.vue?vue&type=template&id=bb3f057e"
import script from "./balkenMitBildPolstermaterial.vue?vue&type=script&lang=js"
export * from "./balkenMitBildPolstermaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__